import AuthService from "../../service";
const Banner = {
  getBanner(page, search, sort_branch) {
    return AuthService.get(
      `banner/banner?` +
        `page=${page}` +
        `&sort_date=${sort_branch}` +
        `&search=${search}`
    );
  },
  showBanner(id) {
    return AuthService.get(`banner/banner/${id}`);
  },
  createBanner(data) {
    return AuthService.post(`banner/banner`, data);
  },
  updateBanner(id, data) {
    console.log("data", data);
    return AuthService.put(`banner/banner/${id}`, data);
  },
  deleteBanner(id) {
    return AuthService.delete(`banner/banner/${id}`);
  }
};
export default Banner;
